import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const processed = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = location.hash || window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;

    if (!sessionId) {
      navigate("/login", { replace: true });
      return;
    }

    (async () => {
      try {
        const res = await fetch(`${API}/auth/session`, {
          method: "POST",
          headers: { "X-Session-ID": sessionId },
          credentials: "include",
        });
        if (!res.ok) throw new Error("Auth failed");
        const user = await res.json();
        window.history.replaceState(null, "", "/admin");
        navigate("/admin", { replace: true, state: { user } });
      } catch (e) {
        setError("Sign-in failed. Please try again.");
        setTimeout(() => navigate("/login", { replace: true }), 1600);
      }
    })();
  }, [location, navigate]);

  return (
    <div className="min-h-screen bg-ink-900 grid place-items-center text-white" data-testid="auth-callback">
      <div className="text-center">
        {error ? (
          <p className="font-mono text-sm text-red-400">{error}</p>
        ) : (
          <>
            <Loader2 className="animate-spin mx-auto text-acid" size={32} />
            <p className="mt-4 font-mono text-[11px] uppercase tracking-[0.25em] text-white/50">
              Signing you in…
            </p>
          </>
        )}
      </div>
    </div>
  );
}
